// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.inquiry-form-container {
  padding: 16px;
  background-color: white;
  border-radius: 16px;
  font-family: "Proxima Nova", sans-serif;
}
.inquiry-form-container .listing-agent, .inquiry-form-container .buyer-agent {
  display: flex;
  justify-content: space-between;
}
.inquiry-form-container .listing-agent > div, .inquiry-form-container .buyer-agent > div {
  display: flex;
  align-items: center;
  column-gap: 8px;
}
.inquiry-form-container .listing-agent > div > img, .inquiry-form-container .buyer-agent > div > img {
  width: 32px;
  height: 32px;
  border-radius: 100px;
  object-fit: contain;
}
.inquiry-form-container .listing-agent > div .details, .inquiry-form-container .buyer-agent > div .details {
  flex-direction: column;
  row-gap: 4px;
}
.inquiry-form-container .listing-agent > div .details .name, .inquiry-form-container .buyer-agent > div .details .name {
  display: flex;
  align-items: center;
  column-gap: 4px;
}
.inquiry-form-container .listing-agent > div .details > p, .inquiry-form-container .listing-agent > div .details div > p, .inquiry-form-container .buyer-agent > div .details > p, .inquiry-form-container .buyer-agent > div .details div > p {
  font-size: 12px;
  font-weight: 700;
  color: var(--secondary-color-1);
  margin: 0;
}
.inquiry-form-container .listing-agent > div .details > p.company, .inquiry-form-container .listing-agent > div .details div > p.company, .inquiry-form-container .buyer-agent > div .details > p.company, .inquiry-form-container .buyer-agent > div .details div > p.company {
  font-size: 12px;
  color: #5F5F5F;
  font-weight: 500;
}
.inquiry-form-container .listing-agent .verified-agent, .inquiry-form-container .buyer-agent .verified-agent {
  display: flex;
  align-items: center;
  padding: 6px 10px;
  border-radius: 10px;
  column-gap: 8px;
  background-color: #FEF7DE;
}
.inquiry-form-container .listing-agent .verified-agent > div, .inquiry-form-container .buyer-agent .verified-agent > div {
  display: flex;
  flex-direction: column;
}
.inquiry-form-container .listing-agent .verified-agent > div p, .inquiry-form-container .buyer-agent .verified-agent > div p {
  margin: 0;
  font-size: 10px;
  color: #2a2a2a;
  line-height: normal;
  font-weight: 700;
}
.inquiry-form-container .listing-agent .verified-agent > div span, .inquiry-form-container .buyer-agent .verified-agent > div span {
  line-height: normal;
  font-size: 8px;
  font-weight: 500;
  color: #5F5F5F;
}
.inquiry-form-container .listing-agent > button, .inquiry-form-container .buyer-agent > button {
  font-weight: 700;
  background: white;
  border: 1px solid var(--secondary-color-5);
  color: var(--secondary-color-5);
  display: flex;
  align-items: center;
}
.inquiry-form-container .listing-agent > button > svg, .inquiry-form-container .buyer-agent > button > svg {
  margin-right: 5px;
}
.inquiry-form-container .listing-agent > button:hover, .inquiry-form-container .buyer-agent > button:hover {
  opacity: 0.75;
}
.inquiry-form-container .buyer-agent {
  margin-top: 24px;
  padding: 12px 16px;
  background-color: #FEF2F2;
  border-radius: 16px;
  align-items: center;
}
.inquiry-form-container .buyer-agent > p {
  margin: 0;
  color: #9E3645;
  font-weight: 700;
  font-size: 12px;
}
.inquiry-form-container .inquiry-type {
  height: 37px;
  background-color: #F3F3F3;
  padding: 4px;
  display: flex;
  border-radius: 8px;
}
.inquiry-form-container .inquiry-type > div {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1 1;
  color: #BEBEBE;
  font-size: 10px;
  font-weight: 500;
  cursor: pointer;
  transition: 0.3s ease-in-out;
}
.inquiry-form-container .inquiry-type > div:hover {
  opacity: 0.75;
}
.inquiry-form-container .inquiry-type > div.active {
  background-color: var(--primary-color-1);
  color: white;
  font-weight: 700;
  border-radius: 4px;
  cursor: default;
}
.inquiry-form-container .inquiry-type > div.active:hover {
  opacity: 1;
}
.inquiry-form-container .form {
  display: flex;
  animation: fadeIn 0.5s;
  gap: 8px;
}
.inquiry-form-container .form > div {
  width: 100%;
}
.inquiry-form-container > button {
  width: 100%;
  margin-top: 16px;
}

@media (min-width: 481px) and (max-width: 767px), (min-width: 320px) and (max-width: 480px) {
  .inquiry-form-container .map {
    height: 400px;
  }
}`, "",{"version":3,"sources":["webpack://./src/routes/Listing/modules/ListingDetail/modules/InquiryForm/inquiryForm.scss","webpack://./src/assets/styles/_mixins.scss"],"names":[],"mappings":"AAEA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,uCAAA;AADJ;AAGI;EACI,aAAA;EACA,8BAAA;AADR;AAEQ;EACI,aAAA;EACA,mBAAA;EACA,eAAA;AAAZ;AACY;EACI,WAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;AAChB;AACY;EACI,sBAAA;EACA,YAAA;AAChB;AAAgB;EACI,aAAA;EACA,mBAAA;EACA,eAAA;AAEpB;AAAgB;EACI,eAAA;EACA,gBAAA;EACA,+BAAA;EACA,SAAA;AAEpB;AADoB;EACI,eAAA;EACA,cAAA;EACA,gBAAA;AAGxB;AAEQ;EACI,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;AAAZ;AACY;EACI,aAAA;EACA,sBAAA;AAChB;AAAgB;EACI,SAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;AAEpB;AAAgB;EACI,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,cAAA;AAEpB;AAEQ;EACI,gBAAA;EACA,iBAAA;EACA,0CAAA;EACA,+BAAA;EACA,aAAA;EACA,mBAAA;AAAZ;AACY;EACI,iBAAA;AAChB;AACY;EACI,aAAA;AAChB;AAGI;EACI,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;AADR;AAEQ;EACI,SAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;AAAZ;AAGI;EACI,YAAA;EACA,yBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;AADR;AAEQ;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,4BAAA;AAAZ;AACY;EACI,aAAA;AAChB;AACY;EACI,wCAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;AAChB;AAAgB;EACI,UAAA;AAEpB;AAGI;EACI,aAAA;EACA,sBAAA;EACA,QAAA;AADR;AAEQ;EACI,WAAA;AAAZ;AAGI;EACI,WAAA;EACA,gBAAA;AADR;;ACpIY;ED2IJ;IACI,aAAA;EAHV;AACF","sourcesContent":["@import 'assets/styles/_mixins.scss';\n\n.inquiry-form-container {\n    padding: 16px;\n    background-color: white;\n    border-radius: 16px;\n    font-family: 'Proxima Nova', sans-serif;\n\n    .listing-agent, .buyer-agent {\n        display: flex;\n        justify-content: space-between;\n        > div {\n            display: flex;\n            align-items: center;\n            column-gap: 8px;\n            > img {\n                width: 32px;\n                height: 32px;\n                border-radius: 100px;\n                object-fit: contain;\n            }\n            .details {\n                flex-direction: column;\n                row-gap: 4px;\n                .name {\n                    display: flex;\n                    align-items: center;\n                    column-gap: 4px;\n                }\n                > p, div > p {\n                    font-size: 12px;\n                    font-weight: 700;\n                    color: var(--secondary-color-1);\n                    margin: 0;\n                    &.company {\n                        font-size: 12px;\n                        color: #5F5F5F;\n                        font-weight: 500;\n                    }\n                }\n            }\n        }\n        .verified-agent {\n            display: flex;\n            align-items: center;\n            padding: 6px 10px;\n            border-radius: 10px;\n            column-gap: 8px;\n            background-color: #FEF7DE;\n            > div {\n                display: flex;\n                flex-direction: column;\n                p { \n                    margin: 0;\n                    font-size: 10px;\n                    color: #2a2a2a;\n                    line-height: normal;\n                    font-weight: 700;\n                }\n                span {\n                    line-height: normal;\n                    font-size: 8px;\n                    font-weight: 500;\n                    color: #5F5F5F;\n                }\n            }\n        }\n        > button {\n            font-weight: 700;\n            background: white;\n            border: 1px solid var(--secondary-color-5);\n            color: var(--secondary-color-5);\n            display: flex;\n            align-items: center;\n            > svg {\n                margin-right: 5px;\n            }\n            &:hover {\n                opacity: .75;\n            }\n        }\n    }\n    .buyer-agent {\n        margin-top: 24px;\n        padding: 12px 16px;\n        background-color: #FEF2F2;\n        border-radius: 16px;\n        align-items: center;\n        > p {\n            margin: 0;\n            color: #9E3645;\n            font-weight: 700;\n            font-size: 12px;\n        }\n    }\n    .inquiry-type {\n        height: 37px;\n        background-color: #F3F3F3;\n        padding: 4px;\n        display: flex;\n        border-radius: 8px;\n        > div {\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            flex: 1;\n            color: #BEBEBE;\n            font-size: 10px;\n            font-weight: 500;\n            cursor: pointer;\n            transition: .3s ease-in-out;\n            &:hover {\n                opacity: .75;\n            }\n            &.active {\n                background-color: var(--primary-color-1);\n                color: white;\n                font-weight: 700;\n                border-radius: 4px;\n                cursor: default;\n                &:hover {\n                    opacity: 1;\n                }\n            }\n        }\n    }\n    .form {\n        display: flex;\n        animation: fadeIn .5s;\n        gap: 8px;\n        > div {\n            width: 100%;\n        }\n    }\n    > button {\n        width: 100%;\n        margin-top: 16px;\n    } \n}\n\n@include media(mobile) {\n    .inquiry-form-container {\n        .map {\n            height: 400px;\n        }\n    }\n}","@mixin media($keys...) {\r\n    @each $key in $keys {\r\n        @if ($key==mobile) {\r\n            @media (min-width: 481px) and (max-width: 767px),\r\n            (min-width: 320px) and (max-width: 480px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==tablet) {\r\n            @media (min-width: 768px) and (max-width: 1024px),\r\n            (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==nitty-gritt) {\r\n            @media (width: 1024px) and (max-height: 833px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==small-desktop) {\r\n            @media (max-width: 1440px) and (max-height: 833px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==desktop) {\r\n            @media (min-width: 1024px) and (max-width: 1440px) {\r\n                @content;\r\n            }\r\n        }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
